export default __webpack_public_path__ + "static/media/heartbeat.6798a515.png";